import {BaseModel} from '../base/BaseModel';
import {CropUtils} from '../../utils/CropUtils';

/**
 * @class CropModel
 * @extends BaseModel
 *
 * @property {object} attributes
 * @property {string} attributes.uuid
 * @property {string} attributes.name
 */
export class CropModel extends BaseModel {

    initialize () {

        this.microservice = 'md2';
        this.resource = 'crops';
    }

    get idAttribute () {

        return 'uuid';
    }

    get defaults () {

        return {
            name: ''
        };
    }

    /**
     * @returns {string}
     */
    getIcon () {
        const uuid = this.id;

        return uuid && CropUtils.crop[this.id] && CropUtils.crop[this.id].dfIcon;
    }

    static parseGQL(data) {
        const {
            uuid,
            name,
        } = data;

        return {
            uuid,
            name,
        };
    }
}


// WEBPACK FOOTER //
// ./shared/model/md/CropModel.js